import { SET_ORDER } from '../../constants/shipstation';

const initialState = {
  selectedOrder: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDER:
      return {
        ...state,
        selectedOrder: action.selectedOrder,
      };
    default:
      return state;
  }
};

export default reducer;
